import { Component } from '@angular/core';

@Component({
  selector: 'app-not-authorization',
  templateUrl: './not-authorization.component.html',
  styleUrls: ['./not-authorization.component.sass']
})
export class NotAuthorizedComponent {
}
